/** Rating */
export const RATING_REQUEST = 'RATING_REQUEST';
export const RATING_REQUEST_SUCCESS = 'RATING_REQUEST_SUCCESS';
export const RATING_REQUEST_FAILURE = 'RATING_REQUEST_FAILURE';
